/**
 * index.js
 * --------
 * What: Expo/React Native entry point. Registers the root App component and
 * installs early console overrides so verbose logging can be toggled later by
 * remote config.
 * Why: Avoids noisy logs during startup while keeping the ability to restore
 * them when needed for debugging.
 */
import { LogBox } from 'react-native';

// --- Global verbose logging toggle ----------------------------------------
// By default silence console.log/debug until the app decides (via remote
// config) whether verbose logging is enabled. The original functions are
// stored so they can be restored.
if (!globalThis.__originalConsoleLog) {
  globalThis.__originalConsoleLog = console.log.bind(console);
  globalThis.__originalConsoleDebug = console.debug ? console.debug.bind(console) : undefined;
  console.log = () => {};
  console.debug = () => {};
}
//-------------------------------------------------------------------------

LogBox.ignoreLogs([
  'pointerEvents',
]);

// Optionally suppress a few noisy dev logs
const originalWarn = console.warn;
console.warn = (...args) => {
  const message = args[0];
  if (typeof message === 'string' && message.includes('pointerEvents')) {
    return;
  }
  originalWarn.apply(console, args);
};

// Disable development warnings
console.disableYellowBox = true;
if (__DEV__) {
  // console.log = () => {};
}

import { registerRootComponent } from 'expo';
import App from './App';

registerRootComponent(App);

// App (in App.tsx) will later set globalThis.__VERBOSE_LOGS__. When that flag
// is true we restore the original console functions. 